export const canOpen = (fileName: string) => {
  return fileName.endsWith('.pdf') || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png') || fileName.endsWith('.gif');
}

export const isPdf = (fileName: string) => {
  return fileName.endsWith('.pdf');
}
